// src/components/student/VideoPlayer.js
import React, { useEffect } from "react";

export default function VideoPlayer({ video, onClose, onWatched }) {
  // Mark video as watched when opened
  useEffect(() => {
    if (video && onWatched) {
      onWatched(video.id);
    }
    // Prevent scroll on body
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [video]);

  if (!video) return null;

  const embedUrl = `https://www.youtube.com/embed/${video.youtubeId}?autoplay=1&rel=0&modestbranding=1`;

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, zIndex: 200,
        background: "rgba(0,0,0,0.92)",
        backdropFilter: "blur(8px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 24,
        animation: "fadeIn 0.2s ease"
      }}
    >
      <div style={{
        width: "100%", maxWidth: 920,
        animation: "scaleIn 0.3s ease"
      }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 16 }}>
          <div style={{ flex: 1, marginRight: 16 }}>
            <span style={{
              fontSize: 11, fontWeight: 700, color: "var(--sp-yellow)",
              background: "rgba(255,214,0,0.12)", padding: "3px 10px",
              borderRadius: 99, letterSpacing: "0.07em", textTransform: "uppercase",
              marginBottom: 8, display: "inline-block"
            }}>
              {video.category}
            </span>
            <h2 style={{
              fontFamily: "var(--font-body)", fontSize: 20, fontWeight: 700,
              color: "var(--sp-white)", lineHeight: 1.3
            }}>
              {video.title}
            </h2>
            <div style={{ display: "flex", gap: 16, marginTop: 8, alignItems: "center" }}>
              <span style={{ fontSize: 13, color: "var(--sp-gray-light)" }}>
                By {video.instructor}
              </span>
              <span style={{ fontSize: 13, color: "var(--sp-gray-mid)" }}>·</span>
              <span style={{ fontSize: 13, color: "var(--sp-gray-mid)" }}>
                {Number(video.views).toLocaleString()} views
              </span>
              <span style={{ fontSize: 13, color: "var(--sp-gray-mid)" }}>·</span>
              <span style={{ fontSize: 13, color: "var(--sp-gray-mid)" }}>
                {video.duration}
              </span>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              width: 40, height: 40, borderRadius: "50%",
              background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)",
              color: "var(--sp-white)", fontSize: 20, display: "flex",
              alignItems: "center", justifyContent: "center",
              cursor: "pointer", transition: "all 0.15s ease", flexShrink: 0
            }}
            onMouseEnter={e => { e.target.style.background = "rgba(255,255,255,0.15)"; }}
            onMouseLeave={e => { e.target.style.background = "rgba(255,255,255,0.08)"; }}
          >
            ✕
          </button>
        </div>

        {/* Player */}
        <div style={{
          position: "relative",
          paddingTop: "56.25%",
          background: "#000",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 24px 80px rgba(0,0,0,0.8)"
        }}>
          <iframe
            src={embedUrl}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute", inset: 0,
              width: "100%", height: "100%"
            }}
          />
        </div>

        {/* Description */}
        {video.description && (
          <div style={{
            marginTop: 16, padding: "14px 18px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: 10
          }}>
            <p style={{ fontSize: 13, color: "var(--sp-gray-light)", lineHeight: 1.6 }}>
              {video.description}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
